/**
 * SaveSuccessModal Component
 *
 * Success modal shown after saving resource management data.
 * Matches Figma design specs exactly.
 *
 * Design specs:
 * - Size: 592px x 433px
 * - Background: #F6F6F6
 * - Border radius: 20px
 * - Green checkmark icon: 52x52
 * - Title: "Salvo com sucesso!" (32px bold, #1D1D1D)
 * - Description: ANCINE warning message (16px, #3D3D3D)
 * - Button: "Continuar para o orçamento" (green #13D480)
 */

import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogOverlay,
  DialogPortal,
} from "@/components/ui/dialog";

interface SaveSuccessModalProps {
  open: boolean;
  onContinue: () => void;
}

export function SaveSuccessModal({ open, onContinue }: SaveSuccessModalProps) {
  return (
    <Dialog open={open}>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent
          className="bg-[#F6F6F6] rounded-[20px] border-none shadow-lg p-0 w-[592px] max-w-[592px]"
          // Remove default close button
          onPointerDownOutside={(e) => e.preventDefault()}
          onEscapeKeyDown={(e) => e.preventDefault()}
        >
          <div className="flex flex-col gap-[16px] items-center justify-center p-[40px]">
            {/* Green Checkmark Icon */}
            <CheckCircle2 size={52} className="text-[#13D480]" strokeWidth={2} />

            {/* Title */}
            <h2 className="text-[32px] font-bold text-[#1D1D1D] text-center w-[310px]">
              Salvo com sucesso!
            </h2>

            {/* Description */}
            <p className="text-[16px] text-[#3D3D3D] text-center w-[374px] leading-normal">
              Certifique-se que os valores lançados estão de acordo com os
              parâmetros da ANCINE e aprovados pela agência.
            </p>

            {/* Continue Button */}
            <Button
              onClick={onContinue}
              className="bg-[#13D480] hover:bg-[#10b66d] text-[#F6F6F6] h-[59px] w-[374px] text-[16px] font-bold rounded-[10px] mt-[16px]"
            >
              Continuar para o orçamento
            </Button>
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
